function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var InotificationCircleWhite = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    notChangeable: true
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.3778 7.15538C9.84451 7.46648 8.68899 8.84421 8.68899 10.4664V10.933C8.68899 12.9774 8.46678 14.1774 7.51125 15.3329H16.5109C15.5554 14.1774 15.3332 12.9774 15.3332 10.933V10.4442C15.3332 8.84421 14.1999 7.46648 12.6666 7.15538V7.08872V6.02209C12.6666 5.66654 12.3778 5.37766 12.0222 5.37766C11.6667 5.37766 11.3778 5.66654 11.3778 6.02209V7.08872V7.15538ZM12 17.9995C12.8222 17.9995 13.5111 17.3773 13.6222 16.5773C13.6444 16.4662 13.5555 16.3551 13.4222 16.3551H10.5778C10.4445 16.3551 10.3556 16.4662 10.3778 16.5773C10.4889 17.3773 11.1778 17.9995 12 17.9995Z",
    fill: "white"
  }));
});